var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_c('font-awesome-icon',{attrs:{"icon":['fab', _vm.icon],"color":_vm.icon_color}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.url}},[_vm._v(" "+_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }